<a class="individual-entity-name line-height-16" [routerLink]="link">
  <div class="color-gray-900">{{ entityName }}</div>

  <div class="color-gray-700">
    <span>{{ entityNumberName }}</span>
    <span>{{ entityNumber }}</span>
  </div>
</a>
